<template>
  <draggable
    :class="classDraggable"
    class="item item-draggable"
    tag="ul"
    :list="subMenu"
    :group="{ name: 'g1' }"
    @end="saveCategories()"
    :force-fallback="true"
  >
    <li
      v-for="(el, index) in subMenu"
      :key="el.name"
      :class="!sub ? 'border-drag' : ''"
    >
      <div :class="`row align-items-center ${sub ? 'py-3' : 'py-2'}`">
        <div class="col-auto" :class="!sub ? 'border-drag-bottom' : ''">
          <div class="moveIcon text-center">
            <i class="fas fa-bars"></i>
          </div>
        </div>
        <div class="col pl-0">
          <div class="text text-left">
            <span class="section-name" @click="onClick(el, index)">
              {{ normalizeName(el.name) }}</span
            >
          </div>
        </div>
        <div class="col-auto">
          <div class="removeIcon text-right">
            <a
              :href="'https://' + siteUrl + el.route"
              target="_blank"
              class="btn btn-white p-2"
            >
              <i class="fal fa-link text-dark opacity-50"></i>
            </a>
            <button class="btn btn-white p-2">
              <i
                class="fal fa-pen text-dark opacity-50"
                @click="onClick(el, index)"
              ></i>
            </button>
          </div>
        </div>
      </div>
      <nested-draggable
        v-if="sub"
        :subMenu="el.subMenu"
        :siteUrl="siteUrl"
        classDraggable="item item-draggable pl-4"
        :sub="false"
        :onClick="onClick"
        :saveCategories="saveCategories"
      />
    </li>
  </draggable>
</template>
<script>
import draggable from "vuedraggable";
export default {
  props: {
    subMenu: {
      required: true,
      type: Array,
    },
    siteUrl: {
      required: true,
      type: String,
    },
    classDraggable: {
      required: false,
      type: String,
    },
    sub: {
      type: Boolean,
      required: true,
    },
    onClick: {
      type: Function,
    },
    saveCategories: {
      type: Function,
    },
  },
  components: {
    draggable,
  },
  name: "nested-draggable",
  methods: {
    normalizeName(text) {
      text = text.replace("<p>", "");
      text = text.replace("</p>", "");
      return text;
    },
  },
};
</script>
<style scoped>
.dragArea {
  min-height: 50px;
  outline: 1px dashed;
}
ul {
  list-style: none;
  padding-bottom: 0;
  margin-bottom: -1px;
}
.border-drag::after {
  display: block;
  content: "";
  background: #e0e0e0;
  height: 50px;
  position: absolute;
  width: 1px;
  transform: translate3d(-8px, -75px, 0);
}
.border-drag-bottom::after {
  display: block;
  content: "";
  background: #e0e0e0;
  height: 1px;
  position: absolute;
  width: 13px;
  transform: translate3d(-8px, -12px, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/MenuDraggable.vue